import { isNull } from "lodash";

export const formatBoolean = (value: any) => {
  if (value === true || value === "true") return "Ya";
  if (value === false || value === "false") return "Tidak";
  return value;
};

export const formatDate = (value: any) => {
  if (typeof value !== "string") return value;
  const isoDateRegex = /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}:\d{2}(\.\d+)?Z?)?$/;
  if (!isoDateRegex.test(value)) return value;
  const date = new Date(value);
  if (isNaN(date.getTime())) return value;
  return date.toLocaleDateString("id-ID", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
};

export const formatValue = (value: any): string => {
  if (isNull(value)) return ' '
  if (Array.isArray(value)) {
    return value.map(formatValue).join(", ");
  }
  const boolFormatted = formatBoolean(value);
  if (boolFormatted !== value) return boolFormatted;
  const dateFormatted = formatDate(value);
  if (dateFormatted !== value) return dateFormatted;
  return String(value);
};
